import styled from 'styled-components';
import { styled as materialStyled } from '@material-ui/core/styles';
import { Link as ReactLink } from 'react-router-dom';
import {
  TextField as MaterialTextField,
  Button as MaterialButton,
} from '@material-ui/core';

export const Container = styled.div`
  max-width: 460px;
  background-color: #ffffff;

  .profile {
    padding: 40px;
  }
  .selector {
    display: flex;
    flex-direction: row;
  }
`;

export const SelectorButtonSection = styled.div`
  display: flex;
  flex-direction: row;
`;

export const MainFormSection = styled.div`
  padding: 0px 40px 40px 40px;
`;

export const ForgotPasswordForm = styled.div`
  padding: 15px 40px 40px 40px;

  .centered {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .recovery-title {
    font-weight: bold;
    font-size: 24px;
    margin-bottom: 43px;
  }
  .recovery-normal-text {
    font-size: 18px;
    margin-bottom: 16px;
  }
  .reset-password {
    font-weight: bold;
    font-size: 24px;
    margin-bottom: 16px;
  }
`;

export const Logo = styled.img`
  display: flex;
  margin: auto;
  margin-top: 20px;
  margin-bottom: 20px;
  max-height: 200px;
`;

export const Link = styled(ReactLink)`
  display: flex;
  justify-content: center;
  align-items: baseline;
  font-size: 12px;
  letter-spacing: 0.05em;
  font-weight: bold;
  margin-top: 8px;
  &:link,
  &:visited {
    color: #0080ff;
  }
`;

export const TextField = materialStyled(MaterialTextField)({
  marginTop: '8px',
});

export const Button = styled(MaterialButton)`
  && {
    background: #f76d31;
    height: 40px;
    min-width: 80px;
    font-size: 16px;
    color: white;
    margin-top: 8px;
    &:hover {
      background: #f76d31;
    }

    ${(props) =>
      props.cancelButton &&
      `background-color: white;
    border: 1px solid red;
    color: red;
    margin-right: 8px;
    &:hover {
      background-color: white;
    }`};
  }
`;

export const PageSelector = styled.button`
  max-width: 230px;
  width: 100%;
  height: 60px;
  background: white;
  font-weight: bold;
  font-size: 22px;
  cursor: default;
  &[id='not-selected'] {
    cursor: pointer;
    box-shadow: inset 0px 0px 20px rgba(0, 0, 0, 0.25);
  }
`;

export const ErrorMessage = styled.div`
  margin-top: 8px;
  font-size: 12px;
  text-align: center;
  color: #f43636;
`;

export const PasswordMessage = styled.div`
  margin-top: 8px;
  font-size: 14px;
  text-align: center;
  color: #5d5d5d;
`;
